/* Storefront adapter for TNZ's normalized custom preview package. Legacy forms stay independent. */
(() => {
  if (window.__tnzCustomProductBoot) { window.__tnzCustomProductBoot(); return; }
  const configurations = new Map();
  const records = new Map();
  const states = new Map();
  let scheduled = false;
  let ordinal = 0;
  const node = (tag, className) => { const el = document.createElement(tag); if (className) el.className = className; return el; };
  function mountCanvas(record) {
    if (record.canvas?.isConnected) return;
    record.renderer?.destroy();
    const host = (record.form.closest('product-info') || record.form.closest('section'))?.querySelector('.product__media-wrapper') || record.block;
    const old = host.querySelector('.tnz-custom-product__preview'); old?.remove();
    const wrap = node('div', 'tnz-custom-product__preview');
    record.canvas = node('canvas'); record.canvas.setAttribute('aria-label', 'Personalized product preview');
    record.renderStatus = node('small', 'tnz-custom-product__render-status');record.renderStatus.setAttribute('role', 'status');
    const download = node('button', 'tnz-custom-product__download');download.type = 'button';download.textContent = 'Download preview';
    download.addEventListener('click', () => {
      if (!record.ready) return;
      record.canvas.toBlob(blob => { if (!blob) return; const url = URL.createObjectURL(blob); const a = node('a'); a.href = url; a.download = 'custom-preview-2000.png'; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1000); }, 'image/png');
    });
    wrap.append(record.canvas, record.renderStatus, download); host.prepend(wrap);
    if (host !== record.block) host.dataset.tnzCustomActive = 'true';
    record.download = download;
    record.renderer = window.TnzCustomPreview.create(record.canvas, record.product.render);
  }
  async function refresh(record) {
    const manifest = record.product.render;
    const visible = window.TnzCustomPreview.visibleFields(manifest, record.state);
    const activeNames = new Set();let duplicate = false;
    for (const field of manifest.fields) {
      const item = record.controls.get(field.id);if (!item) continue;
      const active = !!visible[field.id];item.wrapper.hidden = !active;
      if (active && activeNames.has(field.name)) duplicate = true;
      if (active) activeNames.add(field.name);
      for (const input of item.inputs) {
        input.disabled = !active; input.required = active && !!field.required;
        if (field.type === 'select') input.checked = input.dataset.choiceId === record.state[field.id];
        else if (input.value !== record.state[field.id]) input.value = record.state[field.id] ?? '';
      }
      if (item.counter) item.counter.textContent = `${record.state[field.id]?.length ?? 0}/${field.max_length}`;
    }
    const token = ++record.request;record.ready = false;record.download.disabled = true;
    record.canvas.setAttribute('aria-busy', 'true');record.renderStatus.textContent = 'Updating preview…';
    try {
      if (duplicate) throw new Error('Active personalization fields have duplicate names.');
      const drawn = await record.renderer.draw(record.state);
      if (token !== record.request || !record.form.isConnected || !drawn) return;
      record.ready = true;record.renderStatus.textContent = '';record.download.disabled = false;
    } catch (error) { if (token === record.request) record.renderStatus.textContent = error.message || 'Could not render preview.'; }
    finally { if (token === record.request) record.canvas.setAttribute('aria-busy', 'false'); }
  }
  function updateProduct(productId) {
    for (const record of records.values()) if (record.product.productId === productId) void refresh(record);
  }
  function positionQuantity(record) {
    const input = Array.from(record.form.elements).find(control => control.name === 'quantity');
    const quantity = input?.closest('.product-form__quantity');
    if (quantity && !quantity.contains(record.form) && record.block.nextElementSibling !== quantity) record.block.after(quantity);
  }
  function attach(form, product) {
    form.dataset.tnzCustomPreview = 'true';
    form.querySelector('.tnz-personalization')?.remove();
    const block = node('div', 'tnz-custom-product');block.dataset.productId = product.productId;
    const heading = node('h3');heading.textContent = 'Personalize your product';block.append(heading);
    let state = states.get(product.productId);
    if (!state) { state = Object.fromEntries(product.render.fields.map(f => [f.id, f.type === 'select' ? f.choices[0]?.id ?? '' : ''])); states.set(product.productId, state); }
    const record = { form, product, block, state, controls: new Map(), request: 0, ready: false };
    for (const field of product.render.fields) {
      const wrapper = node('div', 'tnz-custom-product__field');const id = `tnz-custom-${++ordinal}`;
      const container = field.type === 'select' ? node('fieldset') : wrapper;
      const label = node(field.type === 'select' ? 'legend' : 'label');label.textContent = field.name + (field.required ? ' *' : '');
      if (field.type !== 'select') label.htmlFor = id;
      container.append(label);if (container !== wrapper) wrapper.append(container);
      const property = `properties[${field.name.replaceAll('[', '(').replaceAll(']', ')')}]`;
      const inputs = [];let counter;
      if (field.type === 'select') {
        const choices = node('div', 'tnz-custom-product__choices');container.append(choices);
        field.choices.forEach((choice, n) => {
          const row = node('label', 'tnz-custom-product__choice');row.title = choice.label;
          const input = node('input');input.type = 'radio';input.id = `${id}-${n}`;input.name = property;input.value = choice.label;input.setAttribute('aria-label', choice.label);input.dataset.choiceId = choice.id;
          const image = node('img');image.src = product.render.assets[choice.image].url;image.alt = choice.label;image.width = image.height = 76;image.loading = 'lazy';
          const text = node('span', 'visually-hidden');text.textContent = choice.label;
          input.addEventListener('change', () => { if (input.checked) { state[field.id] = choice.id; updateProduct(product.productId); } });
          row.append(input, image, text);choices.append(row);inputs.push(input);
        });
      } else if (field.type === 'text') {
        const input = node('input');input.type = 'text';input.id = id;input.name = property;input.maxLength = field.max_length;input.autocomplete = 'off';
        input.addEventListener('input', () => { window.TnzCustomPreview.setFieldValue(product.render, state, field.id, input.value); updateProduct(product.productId); });
        counter = node('small', 'tnz-custom-product__counter');container.append(input, counter);inputs.push(input);
      }
      if (field.instructions) { const help = node('small');help.textContent = field.instructions;container.append(help); }
      record.controls.set(field.id, { wrapper, inputs, counter });block.append(wrapper);
    }
    const summary = node('div', 'tnz-custom-product__summary');summary.setAttribute('role', 'status');block.append(summary);
    form.prepend(block);records.set(form, record);positionQuantity(record);mountCanvas(record);void refresh(record);
    form.addEventListener('submit', event => {
      if (!record.ready || !form.reportValidity()) { event.preventDefault();event.stopImmediatePropagation();return; }
      if (product.localPreview) {
        event.preventDefault();event.stopImmediatePropagation();
        summary.replaceChildren();const heading = node('strong');heading.textContent = 'Local test — nothing added to cart';summary.append(heading);
        const visible = window.TnzCustomPreview.visibleFields(product.render, state);
        for (const field of product.render.fields.filter(f => visible[f.id])) { const line = node('div');const value = field.type === 'select' ? field.choices.find(c => c.id === state[field.id])?.label : state[field.id];line.textContent = `${field.name}: ${value ?? ''}`;summary.append(line); }
      } else if (product.uploads?.url) {
        event.preventDefault();event.stopImmediatePropagation();if(window.TnzCustomCart)void window.TnzCustomCart.submit(record);else summary.textContent='Please reload the page to prepare your preview.';
      }
    }, true);
  }
  function boot() {
    scheduled = false;if (!window.TnzCustomPreview) return;
    for (const [form, record] of records) if (!form.isConnected) { record.renderer?.destroy();records.delete(form); }
    document.querySelectorAll('script[data-tnz-custom-config]').forEach(script => {
      try { const product = JSON.parse(script.dataset.config || script.textContent);for (const asset of Object.values(product.render?.assets || {})) if (asset.url?.startsWith('//')) asset.url = `https:${asset.url}`;if (product.productId && Array.isArray(product.variantIds) && product.render?.schema === 1) configurations.set(String(product.productId), product); } catch { /* Unrelated forms remain untouched. */ }
    });
    for (const form of document.querySelectorAll('form[action]')) {
      let url;try { url = new URL(form.action, location.href); } catch { continue; }
      if (!/\/cart\/add(?:\.js)?\/?$/.test(url.pathname) || form.matches('.installment,[id^="product-form-installment-"]')) continue;
      if (!Array.from(document.querySelectorAll('button[type=submit],input[type=submit],button:not([type])')).some(button => button.form === form)) continue;
      const variant = form.querySelector('[name=id]')?.value;
      const product = [...configurations.values()].find(p => p.variantIds.map(String).includes(String(variant)));
      if (!product) continue;
      if (!records.has(form)) attach(form, product);
      else if (!records.get(form).canvas?.isConnected) { mountCanvas(records.get(form));void refresh(records.get(form)); }
      positionQuantity(records.get(form));
    }
  }
  function schedule() { if (!scheduled) { scheduled = true;requestAnimationFrame(boot); } }
  window.__tnzCustomProductBoot = schedule;
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('tnz-custom-preview-config', schedule);document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
